import "./index.scss";
import React from "react";
import { connect } from "react-redux";
import Fingerprint2 from "fingerprintjs2";
import { createUserRequest } from "../../../../action/auth-actions";
import { termsFetchRequest } from "../../../../action/terms-actions";
import { subscriptionPlansFetchRequest } from "../../../../action/subscription-plan-actions";
import SignUpWithFacebook from "../sign-up-with-facebook";
import SignUpWithGoogle from "../sign-up-with-google";
import { setLoading } from "../../../../action/loading-actions";
import logoIcon from '../../../../../asset/BaseMapLogo.png'

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      FirstName: '',
      LastName: '',
      Email: '',
      StateId: '',
      PhotoUrl: '',
      DeviceId: '',
      Platform: '',
      IpAddress: '',
      Password: '',
      Country: 0,
      State: '',
      verifyPassword: '',
      emailError: '',
      authorized: false,
      states: [],
      termsAgreement: false,
      termsAgreementError: '',
      termsId: null,
      termsAcceptDate: '',
      loggedIn: true,
      options: [],
      bgColor: '#C4C4C4',
      showfreeTrialMessage: true,
      freeSignup: false,
      country: [
        { value: "0", label: "" },
        { value: "1", label: "United States" },
        { value: "2", label: "Canada" },
        { value: "3", label: "Other" },
      ],
      selectedOption: null,
    };
    this.handleSignup = this.handleSignup.bind(this);
  }

  componentDidMount() {
    this.setState({ loggedIn: false });
    this.getIpAddress();
    this.getPlatform();
    this.props.getSubPlans();
    this.props.getTerms();
  }

  componentDidUpdate(prevprops, prevState) {

  }

  getPlatform() {
    const options = {};
    Fingerprint2.getV18(
      options,
      function (results, components) {
        let platform = components[14].value;
        this.setState({ platform: platform });
      }.bind(this)
    );
  }

  getIpAddress() {
    // $(document).ready(
    //   function () {
    //     $.getJSON(
    //       'https://jsonip.com/?callback=?',
    //       function (data) {
    //         let ip = data.ip
    //         this.setState({ ipAddress: ip })
    //       }.bind(this)
    //     )
    //   }.bind(this)
    // )
  }

  selectHandleChange(e) {
    const selectedCountry = e.target.value;
    // if (this.state.FirstName && this.state.LastName && this.validEmail(this.state.Email) && this.state.Password.length < 6 && this.state.termsAgreement == true && this.state.Password == this.state.verifyPassword) {
    //   console.log('its is working man')
    //   this.setState({ bgColor: '#589500' })
    // }
    this.setState({ selectedOption: selectedCountry, });

    if (this.state.FirstName && this.state.LastName && this.state.Email && this.state.Password && this.state.verifyPassword && this.state.termsAgreement) {
      console.log('its is working man in agree')
      this.setState({ bgColor: '#589500' })
    } else {
      this.setState({ bgColor: 'red' })
    }
  };

  handleSignup(e) {
    e.preventDefault()
    // this.props.setLoading(true)
    // this.setState({
    //   termsAgreementError: this.state.termsAgreement == false ? 'You must accept the terms to create an account' : ''
    // })
    //}
    if (!this.state.FirstName)
      return this.setState({ emailError: 'Please enter your first name' })
    if (!this.state.LastName)
      return this.setState({ emailError: 'Please enter your last name' })
    if (this.state.LastName.length == 1)
      return this.setState({ emailError: `LastName must be a minimum length of '2'` })
    if (!this.validEmail(this.state.Email))
      return this.setState({ emailError: 'Please enter a valid email address' })
    if (this.validEmail(this.state.Email))
      this.setState({ emailError: '' })
    if (this.state.Password.length < 8)
      return this.setState({
        emailError: 'Password must be at least 8 characters long'
      })
    if (this.state.Password.length >= 8)
      this.setState({
        emailError: ''
      })
    if (this.state.Password != this.state.verifyPassword)
      if (this.state.verifyPassword == '') {
        this.setState({ emailError: 'Please enter Confirm Password' })
      } else {
        this.setState({ emailError: 'Confirm password does not match Password' })
      }
    if (this.state.Password === this.state.verifyPassword) this.setState({ emailError: '' })
    if (this.state.termsAgreement == false) {
      this.setState({
        termsAgreementError: this.state.termsAgreement == false ? 'You must accept the terms to create an account' : ''
      })
    }

    if (this.state.emailError.length > 0) {
      this.props.setLoading(false)
    }
    if (this.state.emailError == '') {
      this.setState({
        bgColor: '#589500'
      })
    }
    if (
      this.validEmail(this.state.Email) &&
      this.state.Password.length >= 5 &&
      this.state.Password === this.state.verifyPassword &&
      this.state.termsAgreement &&
      this.state.termsId
    ) {
      let userObj = {
        FirstName: this.state.FirstName,
        LastName: this.state.LastName,
        Email: this.state.Email,
        DeviceId: this.state.DeviceId,
        Platform: this.state.Platform,
        IpAddress: this.state.IpAddress,
        Password: this.state.Password,
        termsId: this.state.termsId,
        termsAcceptDate: this.state.termsAcceptDate,
        countryId: this.state.selectedOption,
      };

      this.props.setLoading(true)
      this.props.createUserLogin(userObj)
        .then(res => {
          let err = res.message ? res : null
          // if (res) {
          //   this.forceUpdate()
          // }
        }).catch(err => {
          let jdata = JSON.stringify(err, null, 2)
          let data = JSON.parse(jdata)
          this.props.setLoading(false)
          let errorsJson = JSON.parse(data.response.text)
          if (err) {
            if (err.status === 503) {
              this.setState({
                emailError: 'BaseMap is offline for updates'
              })
              return
            }
            if (err.status === 400) {
              if (errorsJson?.errors?.LastName[0]) {
                this.setState({
                  emailError: `LastName must be a minimum length of '2'` // Show API message
                });
              } else {
                this.setState({
                  emailError: 'A user with this email already exists'
                })
              }
              return
            }
            if (err.status === 404) {
              this.setState({
                emailError: 'Invalid email address'
              })
              return
            }
            this.setState({
              emailError: 'Account was not created, please try again'
            })
            return
          }
        })
    }
  }

  validEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  handleChange = e => {
    this.setState({ loggedIn: false, emailError: '' })
    let { name, value, checked } = e.target
    if (value === 'termsAgreement') {
      this.setState({ [value]: checked }, () => {
        if (this.state.termsAgreement == true) {
          this.setState({
            termsId: this.props.terms.id,
            termsAcceptDate: new Date(),
            termsAgreementError: ''
          })
        } else {
          this.setState({
            termsId: null,
            termsAcceptDate: ''
          })
        }
      })
    } else {
      this.setState({ [name]: value })
    }
    if (this.state.FirstName && this.state.LastName && this.state.Email && this.state.Password && this.state.termsAgreement == true) {
      console.log('its is working man')
      this.setState({ bgColor: '#589500' })
    } else {
      console.log('nooo')
      this.setState({ bgColor: 'red' })
    }
  }

  handlefreeTrialMessage(e) {
    this.setState({
      showfreeTrialMessage: !this.state.showfreeTrialMessage
    })
  }

  render() {
    const boxId = 'social-login'
    const css = {
      box: 'dialog-box-' + boxId,
      header: 'dialog-box-' + boxId + '__header',
      body: 'dialog-box-' + boxId + '__body',
      footer: 'dialog-box-' + boxId + '__footer'
    }
    const content = {
      header: (
        <img src={logoIcon} style={{ width: '100%', height: 31, marginBottom: 20 }}></img>
      ),
      body: (
        <React.Fragment>
          <p className="signup-header-style">Free Sign Up</p>
          <div style={{ display: 'flex', flexDirection: 'column', }}>
            <label className="signup-label-style">Email</label>
            <input
              type="text"
              name="Email"
              // placeholder="example@email.com"
              // autoComplete="email"
              value={this.state.Email}
              onChange={e => this.handleChange(e)}
              className="signup-input-style"
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }} >
            <div style={{ display: 'flex', flexDirection: 'column', width: '50%', marginRight: 10 }}>
              <label className="signup-label-style">First Name</label>
              <input
                type="text"
                name="FirstName"
                // placeholder="First name"
                value={this.state.FirstName}
                onChange={(e) => this.handleChange(e)}
                className="signup-input-style"
              // style={{ width: '100%' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
              <label className="signup-label-style">Last Name</label>
              <input
                type="text"
                name="LastName"
                // placeholder="Last name"
                value={this.state.LastName}
                onChange={(e) => this.handleChange(e)}
                className="signup-input-style"
              // style={{ width: '100%' }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', }}>
            <label className="signup-label-style">Country</label>
            <select
              style={{
                cursor: "pointer",
                display: "inline-block",
                position: "relative",
                width: "100%",
                color: "inherit",
                border: "0.1px solid inherit",
                padding: '3px',
                height: '40px',
              }}
              className="signup-input-style"
              // value={this.state.country}
              onChange={(e) => this.selectHandleChange(e)}
            >
              {/* <option value=''>-- Choose Country --</option> */}
              {this.state.country.map((state) => {
                return (
                  <option key={state.value} value={state.value}>
                    {state.label}
                  </option>
                );
              })}
            </select>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label className="signup-label-style">
              Password<span> (min 8 characters)</span>
            </label>
            <input
              type="password"
              name="Password"
              value={this.state.Password}
              onChange={(e) => this.handleChange(e)}
              className="signup-input-style"
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label className="signup-label-style">Confirm Password</label>
            <input
              type="password"
              name="verifyPassword"
              value={this.state.verifyPassword}
              onChange={(e) => this.handleChange(e)}
              className="signup-input-style"
            />
          </div>
        </React.Fragment>

        // <React.Fragment>
        //   <div style={{ marginBottom: 10 }}>
        //     <label style={{ width: '100%', textAlign: 'right' }}>
        //       <a href="#forgot-Password" onClick={e => this.props.slideInOutBackground('forgotPassword')}>
        //         Forgot Password?
        //       </a>
        //     </label>
        //   </div>

        //   <p id="login-email-error" >{this.state.error}</p>
        //   <div style={{ paddingBottom: '25px' }} className='terms-condition-style'>
        //     <p className='terms-condition-style'>
        //       By logging-in you agree to our &nbsp;
        //       <a
        //         href="https://www.basemap.com/terms-of-use/"
        //         target='_blank'
        //         onClick={() => {
        //           this.props.openTermsUpdate()
        //         }}
        //       >
        //         terms of service.
        //       </a>
        //     </p>
        //   </div>
        //   <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
        //     <button type="submit" value="Submit" id="login-button" onClick={e => this.handleLogin(e)} style={{ width: "50%", margin: '0.5em' }}>
        //       Login
        //     </button>
        //     <button onClick={e => this.props.slideInOutBackground('showLogin')} style={{ width: '50%', backgroundColor: 'gray', margin: '0.5em' }}>
        //       Cancel
        //     </button>
        //   </div>


        //   <div />
        // </React.Fragment>
      ),
      footer: (
        <React.Fragment>
          <div style={{ width: '100%', display: 'flex', alignItems: 'center', height: '10%' }}>
            <p style={{ width: '100%', textAlign: 'center', color: 'red', fontSize: 10 }}>{this.state.emailError ? this.state.emailError : this.state.termsAgreementError ? this.state.termsAgreementError : this.state.emailError && this.state.termsAgreementError ? this.state.emailError : ''}</p>
          </div>
          <div style={{ width: '100%', display: 'flex', alignItems: 'center', height: '10%' }}>
            <input
              type="checkbox"
              name="termsAgreement"
              value="termsAgreement"
              checked={this.state.termsAgreement}
              onChange={(e) => this.handleChange(e)}
              className="signup-checkbox-style"
              style={{
                width: 20,
                height: 20,
                backgroundColor: '#C4C4C4',
                borderRadius: 5,
                opacity: 1,
              }}
            />
            <div >
              <label className="signup-label-style">
                I have read and agree to the{' '}
                <a
                  href="https://www.basemap.com/terms-of-use/"
                  target="_blank"
                  onClick={() => {
                    this.props.openTermsUpdate();
                  }}
                >
                  terms of service.
                </a>
              </label>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', height: '50%' }}>
            <button type="submit" value="Submit" id="login-button" onClick={e => this.handleSignup(e)} style={{ width: "100%", margin: '0.5em', height: 40, }}>
              Create Account
            </button>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30%' }}>
            <p style={{}}>
              <a target="_blank" rel="noopener noreferrer" onClick={e => this.props.slideInOutBackground('showLoginFromSignUp')}   >
                <span style={{ color: '#959595', textDecoration: 'none' }}> Already Have an Account?</span>
                <span className="custom-link-login"> Log In</span>
              </a>
            </p>
          </div>
          {/* <button id="signup-button" onClick={(e) => this.handleSignup(e)}>
            Create my account
          </button> */}
        </React.Fragment >
      ),
    };

    return (
      <div className="signup-container" >
        <div className="signup-container-child">
          <div className='' style={{ height: '10%', width: '100%' }}>{content.header}</div>
          <div className='' style={{ height: '60%', width: '100%' }}>{content.body}</div>
          <div className={css.footer}
            style={{ height: '30%', width: '100%' }}
          >{content.footer}</div>

        </div>
      </div>
      // <div id={boxId} className={css.box + "-parent"}>
      //   <div className={css.box + "-parent__header"}>
      //     <div
      //       className={
      //         !this.state.showfreeTrialMessage
      //           ? css.box + "-parent__header__" + "show"
      //           : css.box + "-parent__header__" + "hide"
      //       }
      //     >
      //       <p>
      //         A free account is required to sync your data across multiple
      //         devices.
      //       </p>
      //       <p>
      //         <span>
      //           If you already started a free trial on your mobile device,
      //         </span>{" "}
      //         you will need to set-up a free account on your mobile device and
      //         then{" "}
      //         <a
      //           href="#no"
      //           onClick={(e) =>
      //             this.props.slideInOutBackground("showLoginDefault")
      //           }
      //         >
      //           LOGIN
      //         </a>{" "}
      //         to the desktop website to view your saved content.
      //       </p>
      //       <p>
      //         <span>
      //           If you start(ed) a free trial from the desktop, you can view
      //           your saved content by logging into your mobile device.
      //         </span>
      //       </p>
      //     </div>
      //   </div>
      //   {
      //     // this.state.freeSignup &&  
      //     <div
      //       className={
      //         this.state.showfreeTrialMessage
      //           ? css.box + " " + css.box + "-parent__body__" + "show"
      //           : css.box + " " + css.box + "-parent__body__" + "hide"
      //       }
      //     >
      //       <div style={{ height: 500 }}>
      //         <div className={css.header}>{content.header}</div>
      //         <div className={css.body}>{content.body}</div>
      //         <div className={css.footer}>{content.footer}</div>
      //       </div>
      //     </div>}
      //   <div className={css.box + "-parent__footer"}>
      //     <button
      //       className={
      //         !this.state.showfreeTrialMessage
      //           ? css.box +
      //           "-parent__footer__" +
      //           "signUpWithEmail" +
      //           " " +
      //           css.box +
      //           "-parent__footer__" +
      //           "signUpWithEmail__" +
      //           "show"
      //           : css.box +
      //           "-parent__footer__" +
      //           "signUpWithEmail" +
      //           " " +
      //           css.box +
      //           "-parent__footer__" +
      //           "signUpWithEmail__" +
      //           "hide"
      //       }
      //       onClick={(e) => this.handlefreeTrialMessage(e)}
      //     >
      //       <img src="../../../asset/Envelope_Solid_FFFFFF_hdpi.png" />
      //       <span>Sign Up with Email</span>
      //     </button>

      //     {/* <p>or</p> */}

      //     {/* {!this.state.freeSignup &&
      //       <div style={{ width: 320 }}>
      //         <button className="text-botton-free-singnup" onClick={() => this.setState({ freeSignup: true })}> <span className='centered-text' >Free Signup</span></button>
      //         <button className="green-button"> <span className='centered-text'>Email</span></button>
      //         <SignUpWithFacebook />
      //         <SignUpWithGoogle />
      //         <button className="grey-button-signup" onClick={e => this.props.slideInOutBackground('showSignup')}> <span className='centered-text'>Back</span></button>

      //         <div style={{ display: 'flex', marginTop: 20, }}>
      //           <label style={{ letterSpacing: '0.1px' }}>
      //             I have read and agree to the{' '}
      //             <a
      //               href="https://www.basemap.com/terms-of-use/"
      //               target="_blank"
      //               onClick={() => {
      //                 this.props.openTermsUpdate();
      //               }}
      //             >
      //               terms of service.
      //             </a>
      //           </label>
      //         </div>
      //       </div>
      //     } */}
      //   </div>
      // </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.user,
  auth: state.auth,
  subscriptionPlans: state.subscriptionPlans,
  terms: state.terms,
  subscriptionModalShow: state.subscriptionModalShow,
});

const mapDispatchToProps = (dispatch) => ({
  createUserLogin: (userObj) => dispatch(createUserRequest(userObj)),
  getTerms: () => dispatch(termsFetchRequest()),
  getSubPlans: (userObj) => dispatch(subscriptionPlansFetchRequest()),
  setLoading: (bool) => dispatch(setLoading(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
